import { ThemeConfigurationType } from '@monorepo/client-types';
import { theme } from 'antd';
import {
  clientPanelLightTheme,
  common5ersCssVars,
  commonComponentTheme,
  commonCssVars,
  commonLightCssEnv,
} from './common.theme-settings';
import { getThemeFixedColors } from './theme-config.util';

export const token = {
  colorPrimary: '#1A2052',
  colorSuccess: '#179DA6',
  colorWarning: '#FFD30E',
  colorError: '#D20059',
  colorInfo: '#3240C2',
  colorLink: '#3240C2',
  colorBgBase: '#fff',
  colorTextSecondary: '#000000',
  colorText: '#000000',
  colorBgLayout: '#fafafa',
};

export const extraToken = {
  colorBrand: '#1A2052',
  colorAttention: '#1A2052',
  colorActive: '#EB0064',
  colorErrorLight: 'rgb(255, 208, 228)',
  colorSecondary: '#E9C10F',
};

export const fixedFiversToken = getThemeFixedColors({
  ...token,
  ...extraToken,
});

export const LightThemeConfigFivers: ThemeConfigurationType = {
  algorithm: theme.defaultAlgorithm,
  token,
  components: commonComponentTheme,
  cssVars: {
    ...commonCssVars,
    ...commonLightCssEnv,
    ...common5ersCssVars,
    ...token,
    ...extraToken,
    ...fixedFiversToken,
    ...clientPanelLightTheme,
    'color-text-button-primary': '#FFFFFF',
  },
};
